import { IconPropsType } from '..';

export const ResendIcon = ({ ...props }: IconPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="15"
    viewBox="0 0 13 15"
    {...props}
  >
    <path
      d="M1.04979 7.34333C0.519945 9.36735 1.39949 12.1119 3.61425 13.5001C5.74423 14.8354 8.53122 14.6764 10.4387 13.0763C12.4097 11.4337 13.0773 8.78452 12.1342 6.41081C11.3288 4.355 9.03987 2.38398 5.76542 2.81845C5.64886 2.42636 5.2999 0.799805 5.2999 0.799805L2.96783 4.34441L6.81452 6.41081C6.81452 6.41081 6.27407 4.63052 6.15751 4.20665C6.49661 4.20665 6.82511 4.17486 7.13242 4.21724C8.96569 4.45038 10.2797 5.4147 10.8731 7.17378C11.8692 10.1727 9.6333 12.9173 6.81452 12.9491C4.53618 12.9809 2.66052 11.3596 2.385 9.09183C2.33202 8.66795 2.3956 8.23348 2.42739 7.8096C2.43799 7.69303 2.44859 7.60826 2.30023 7.57647C1.88695 7.50229 1.47367 7.42811 1.04979 7.34333Z"
      fill="currentColor"
    />
  </svg>
);
